import {Injectable} from '@angular/core';

import {Router, ActivatedRouteSnapshot} from "@angular/router";
import {Subject} from "rxjs";
import {TaxReturnService} from "../../../swaggerServices";
import {ITaxReturn} from "./tax-return/model/i-tax-return";
import {getFullTaxReturn} from "./get-full-tax-return";

@Injectable()
export class TaxReturnsResolver  {

  taxReturn: ITaxReturn;
  $taxReturn: Subject<ITaxReturn> = new Subject<ITaxReturn>(); // observable for tax return

  constructor(private router: Router,
              private taxReturnService: TaxReturnService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    const taxReturnId = Number(route.paramMap.get('id'));
    const snapshotId = route.queryParams.snapshot ? Number(route.queryParams.snapshot) : null;
    const topLevel = !route.url.find(segment => segment.path === "subcategories") && !route.url[2]
    const subcategoryId = route.url[2]?.path ==="subcategories" ? +route.url[3].path : null

    return this.fetchTaxReturn(taxReturnId,subcategoryId, snapshotId, route.data.requestFullData, topLevel);
  }

  getTaxReturnObs() {
    return this.$taxReturn;
  }

  refresh(taxReturnId: number) {
    if (this.taxReturn && taxReturnId === this.taxReturn.id) {
      const urlPath = this.router.url.split('?')[0];
      const subcategoryMatch = urlPath.match(/\/subcategories\/(\d+)(?:\/|$)/);
      const subcategoryId = subcategoryMatch ? Number(subcategoryMatch[1]) : null;
      const topLevel = subcategoryId == null;
      this.fetchTaxReturn(taxReturnId, subcategoryId, this.taxReturn.snapshotId, this.taxReturn.fullData, topLevel);
    }
  }

  private fetchTaxReturn(taxReturnId: number, subcategoryId: number | null, snapshotId: number|null, requestFullData: boolean, topLevel: boolean) {
    return getFullTaxReturn(this.taxReturnService, taxReturnId, subcategoryId,  snapshotId, requestFullData, topLevel).subscribe(data => {
      this.taxReturn = data;
      this.taxReturn.categories.forEach(c => c.isGlobal = c.taxReturnTypeId === null),
      this.$taxReturn.next(this.taxReturn);
      return data;
    });
  }
}
